import { Account } from "@apaq/orgkit-js";

/**
 * @deprecated
 */
export class Roles {
    public static readonly SEPARATOR = '_';
    public static readonly PREFIX_ORGROLE = 'ORGROLE';

    public static getOrganizationId(role: string): string | undefined {
        if (Roles.isOrganizationRole(role)) {
            const elements = role.split(Roles.SEPARATOR);
            return elements[1];
        } else {
            return undefined;
        }
    }

    public static isOrganizationRole(role: string): boolean {
        return role.startsWith(Roles.PREFIX_ORGROLE + Roles.SEPARATOR);
    }


    public static getPermission(role: string): string | undefined {
        if (Roles.isOrganizationRole(role)) {
            const elements: string[] = role.split(Roles.SEPARATOR);
            return elements[2];
        } else {
            return undefined;
        }
    }

    public static hasRolesForOrganization(id: string, account: Account, requiredRoles: string[]) {
        let lacksRole = false;
        requiredRoles.forEach(requiredRole => {
            let hasRole = false;
            account.roles.forEach(r => {
                const roledata = r.split('_');
                if (roledata[0] === 'ORGROLE' &&
                    roledata[1] === id &&
                    roledata[2] === requiredRole) {
                    hasRole = true;
                }
            });

            if (!hasRole) {
                lacksRole = true;
            }
        });
        return !lacksRole;
    }

    public static getRolesForOrganization(id: string, account: Account) {
        const roles: string[] = [];
        account.roles.forEach(r => {
            const roledata = r.split('_');
            if (roledata[0] === 'ORGROLE' && roledata[1] === id) {
                roles.push(roledata[2]);
            }
        });

        return roles;
    }

}